import {outputKeyFromOutputTypeAndOutputId, Unresolved} from "@cm/template-nodes"
import type {ExternalId, BuilderOutlet, GraphBuilderScope, NodeEvaluator} from "@cm/template-nodes"
import {MattressNode} from "#mattress/nodes/mattress-node"
import type {MattressComponentInstance} from "#mattress/nodes/component/mattress-component-instance"
import type {EvaluatedMattressComponentOutputs, EvaluatedMattressComponentValueType} from "#mattress/nodes/component/mattress-component-types"

export type MattressOutputParameters = {
    name: string
    component: MattressComponentInstance
    outputId: ExternalId
}

export abstract class MattressOutput<P extends MattressOutputParameters = MattressOutputParameters> extends MattressNode<P> {
    // Reads the component-instance output keyed by `output-${type}-${outputId}` out of the resolved
    // EvaluatedMattressComponentOutputs map.
    protected evaluateComponentOutput<T>(
        type: EvaluatedMattressComponentValueType,
        scope: GraphBuilderScope,
        evaluator: NodeEvaluator,
    ): BuilderOutlet<T | null> {
        const {component, outputId} = this.parameters
        return scope.pureLambda(
            scope.tuple(
                evaluator.templateScope.resolve<EvaluatedMattressComponentOutputs>(`componentOutputs-${evaluator.getLocalId(component)}`),
                type,
                outputId,
            ),
            ([outputs, type, outputId]) => {
                if (outputs === Unresolved) return null
                return (outputs[outputKeyFromOutputTypeAndOutputId(type, outputId)] ?? null) as T | null
            },
            `output${component.instanceId}`,
        )
    }
}
